module.exports = __webpack_public_path__ + "img/riekkola_maisema.82dff272.jpg";